import './loading.css';

const Loading = {};
let dom = null;
Loading.installed = false;
Loading.install = (Vue) => {
  // eslint-disable-next-line no-useless-return
  if (Loading.installed) return;
  if (document.querySelector('.vue-loading')) return;

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$loading = {
    hide() {
      if (dom !== null) {
        document.body.removeChild(dom);
        Loading.installed = true;
      }
    },
    show(text) {
      // 创建构造器
      const Profile = Vue.extend({
        template: `<div class="vue-loading">
        <div class="vue-icon fadeIn">
        <van-loading type="spinner" color="#fff" size="24px"></van-loading>
        <span class="iconfontText">${text || '加载中...'}</span>
        </div>
        </div>`,
      });
      dom = new Profile().$mount().$el;
      document.body.appendChild(dom);
      // 阻止遮罩滑动
      document.querySelector('div.vue-loading').addEventListener('touchmove', (e) => {
        e.stopPropagation();
        e.preventDefault();
      });
      Loading.installed = true;
    },
  };
};
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Loading);
}
export default Loading;
